function QtySelectors() {
  console.log('// Init Qty Selectors');
  $('.qty-minus, .qty-plus').off('click').on('click', function(e) {
    e.preventDefault();

    var isPlus = $(e.currentTarget).hasClass('qty-plus');
    var $qty = $(e.currentTarget).closest('.quantity-selector').find('input[type="number"]');
    var qty = $qty.val();

    if (isPlus) {
      qty++;
    }
    else {
      qty--;
      if (qty == 0) return;
    }

    $qty.val(qty);
    $qty[0].dispatchEvent(new Event('change', {'bubbles': true}));
  });
}

function updateCart(p_options) {
  var updates = {};
  updates[p_options.key] = p_options.quantity;

  return new Promise(function(resolve, reject) {
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: {updates: updates},
      success: function(data) {
        //console.log(data);
        resolve(data);
      },
      ajax: true,
      dataType: 'json'
    });
  });
}  

(function($) {  
  $(document).ready(function() {
    console.log('READY');
    
    $(document).on('click', '.product-card-footer-mobile .product-card-interaction-addtocart', function(e) {
      console.log(e);
      
      // trigger actual add to cart
      $(e.currentTarget).closest('.product').find('.addtocart-button-active').trigger('click');
    });
    
    // Quantity selector
    QtySelectors();
    
    // Mini Cart quantity updates
    $(document).on('change', '.cart-mini .cart-item-quantity', function(e) {
      var key = $(e.currentTarget).data('key'),
          qty = $(e.currentTarget).val();
      
      updateCart({
        key: key,
        quantity: qty
      })
      .then(function() {
        $(document).trigger('mini-cart-refresh');
      });
    });
    
    /*
    document.querySelector('.mini-cart-wrap').addEventListener('DOMSubtreeModified', function() {
      var total = 0; 
      $('.cart-item-original-total-price').each(function() {
        var $item = $(this);
        total += parseFloat($item.attr('data-original-line-price'));
      });
      $('.cart-original-total').text(Shopify.formatMoney(total, Shopify.money_format));
    });
    */
  });
})(jQuery);






  $(document).ready(function() {
    $('.announce_close').click(function() {
        $('.custom_announce').remove();
    });
});